import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { SimpleFormIterator as SimpleFormIteratorOriginal } from 'react-admin';

const simpleFormIteratorStyles = theme => ({
  root: {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  line: {
    border: 0,
  },
  index: {
    display: 'none',
  },
  action: {
    display: 'flex',
    right: 0,
  },
  leftIcon: {
    display: 'none',
  },
});

export const SimpleFormIterator = withStyles(simpleFormIteratorStyles)(SimpleFormIteratorOriginal);
